/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SourcingSearchPhoto
 */
export interface SourcingSearchPhoto {
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchPhoto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchPhoto
     */
    baseUrl?: string;
}

/**
 * Check if a given object implements the SourcingSearchPhoto interface.
 */
export function instanceOfSourcingSearchPhoto(value: object): value is SourcingSearchPhoto {
    return true;
}

export function SourcingSearchPhotoFromJSON(json: any): SourcingSearchPhoto {
    return SourcingSearchPhotoFromJSONTyped(json, false);
}

export function SourcingSearchPhotoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchPhoto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'baseUrl': json['baseUrl'] == null ? undefined : json['baseUrl'],
    };
}

export function SourcingSearchPhotoToJSON(value?: SourcingSearchPhoto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'baseUrl': value['baseUrl'],
    };
}

